// @flow
import type { DataLoaderParams } from '../../../types/DataLoaderParams';
import { recordAnalyticsForSavedSearchesPageView } from '../../../redux/modules/analytics';
import { sleep } from '../../../utils/sleep';

const SAVED_SEARCHES_PAGE_MANAGE_TAB = 'saved searches - recent tab';

export default ({ store }: DataLoaderParams) => {
    const { dispatch } = store;
    return Promise.all([sleep(1500)]).then(() => {
        return dispatch(recordAnalyticsForSavedSearchesPageView(SAVED_SEARCHES_PAGE_MANAGE_TAB));
    });
};
